// @ts-nocheck
import {
  buildColumnMap,
  buildNormalizedAliases,
  buildStandardRecord,
  cleanText,
  guessPharmaceuticalCompanyName,
  normalizeHeader,
  shouldSkipRecord,
} from './settlementTemplateHelpers.js';

const MEDI_LINK_FIELD_ALIASES = {
  hospitalName: ['병원명'],
  pharmaceuticalCompanyName: ['제약사'],
  drugName: ['제품명'],
  unitPrice: ['약가'],
  quantity: ['수량'],
  prescriptionAmount: ['처방금액'],
  feeRate: ['수수료율 (기본+인센)', '수수료율'],
  settlementAmount: ['지급액'],
  settlementStatus: ['정산여부'],
  note: ['비고'],
  note2: ['비고2'],
};

const REQUIRED_HEADERS = [
  '처방월',
  '병원명',
  '제약사',
  '제품명',
  '약가',
  '수량',
  '처방금액',
  '수수료율 (기본+인센)',
  '지급액',
  '정산여부',
  '비고',
  '비고2',
];

function hasRequiredHeaders(row = []) {
  return REQUIRED_HEADERS.every((header) =>
    row.some(
      (candidate) => normalizeHeader(candidate) === normalizeHeader(header),
    ),
  );
}

function findMediLinkHeaderRowIndex(rows = []) {
  return rows.findIndex(
    (row, rowIndex) => rowIndex < 40 && hasRequiredHeaders(row),
  );
}

const mediLinkTemplate = {
  id: 'medi-link',
  name: '메디링크 템플릿',
  match(context) {
    return context.workbook.SheetNames.some((sheetName) => {
      const rows = context.sheetRowsMap[sheetName] || [];
      return findMediLinkHeaderRowIndex(rows) >= 0;
    });
  },
  extract(context) {
    const extractedRows = [];
    const matchingSheets = context.workbook.SheetNames.filter((sheetName) => {
      const rows = context.sheetRowsMap[sheetName] || [];
      return findMediLinkHeaderRowIndex(rows) >= 0;
    });

    if (matchingSheets.length === 0) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    matchingSheets.forEach((sheetName) => {
      const rows = context.sheetRowsMap[sheetName] || [];
      const headerRowIndex = findMediLinkHeaderRowIndex(rows);
      if (headerRowIndex < 0) return;

      const headerRow = rows[headerRowIndex] || [];
      const columnMap = buildColumnMap(
        headerRow,
        buildNormalizedAliases(MEDI_LINK_FIELD_ALIASES),
      );

      rows.slice(headerRowIndex + 1).forEach((row, rowOffset) => {
        if (
          !Array.isArray(row) ||
          row.every((cell) => cleanText(cell) === '')
        ) {
          return;
        }

        const drugName = cleanText(row[columnMap.drugName]);
        if (!drugName) {
          return;
        }

        const settlementStatus = cleanText(row[columnMap.settlementStatus]);
        const note =
          settlementStatus && settlementStatus !== '정산완료'
            ? [settlementStatus, row[columnMap.note], row[columnMap.note2]]
                .map((value) => cleanText(value))
                .filter(Boolean)
                .join(' / ')
            : '';

        const record = buildStandardRecord({
          fileName: context.file.name,
          sheetName,
          rowIndex: headerRowIndex + rowOffset + 1,
          templateId: this.id,
          detectedPharmaceuticalCompany: cleanText(
            row[columnMap.pharmaceuticalCompanyName],
          ),
          customerName: row[columnMap.hospitalName],
          drugName,
          unitPriceValue: row[columnMap.unitPrice],
          quantityValue: row[columnMap.quantity],
          prescriptionAmountValue: row[columnMap.prescriptionAmount],
          feeRateValue: row[columnMap.feeRate],
          settlementAmountValue: row[columnMap.settlementAmount],
          note,
        });

        if (shouldSkipRecord(record, row)) {
          return;
        }

        extractedRows.push(record);
      });
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: '메디링크',
      templateName: this.name,
    };
  },
};

export default mediLinkTemplate;
